<aside *ngIf="captcha$ | async as captcha; else loader" class="mt-2">
  <div class="row mb-2">
    <div class="col-12 col-md-4">
      <ecm-mat-captcha-steps
        [indications]="indications"
        [selections]="selections"
        [isMobile]="isUserAgentMobile"
        [captchaIndications]="captcha.indications"
      >
      </ecm-mat-captcha-steps>
    </div>
    <div class="col-12 col-md-8 mt-3">
      <div
        class="img-row mb-1"
        [ngClass]="{ disabled: selectionDone(captcha.indications) }"
        *ngFor="let row of captcha.rows; let indexRow = index"
        [attr.data-e2e]="'captcha-row-' + indexRow"
      >
        <img
          class="img-captcha mr-1"
          *ngFor="let img of row; let indexImg = index"
          [src]="img.data"
          (click)="addChoice(captcha.indications, img.data, img.value)"
          [attr.data-e2e]="'captcha-image-' + indexRow + '-' + indexImg"
        />
      </div>
      <p *ngIf="captchaError" class="alert alert-danger" role="alert">
        <span class="alert-icon icon-error-severe" aria-hidden="true"></span>
        <span class="text-mw">{{ errorMessageLabel }}</span>
      </p>
      <div class="d-flex justify-content-between captcha-btn-container mt-2" data-e2e="captcha-buttons">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="deleteSelections(captcha.indications)"
          [disabled]="!selectionInProgress()"
          data-e2e="captcha-button-delete"
        >
          {{ eraseButtonLabel || (i18nPath + '.erase' | translate) }}
        </button>
        <button
          class="btn btn-primary"
          [disabled]="disableSubmitButton(captcha.indications)"
          data-e2e="captcha-button-submit"
          (click)="sendCaptcha(captcha)"
        >
          {{ submitButtonLabel || (i18nPath + '.submit' | translate) }}
        </button>
      </div>
    </div>
  </div>
</aside>

<ng-template #loader>
  <div class="page-loader">
    <ecm-mat-spinner></ecm-mat-spinner>
  </div>
</ng-template>
